var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('main',[_c('fade-transition',{attrs:{"origin":"center","mode":"out-in","duration":250}},[_c('router-view',{ref:"app"})],1)],1),_c('router-view',{attrs:{"name":"footer"}}),_c('notifications',{attrs:{"position":"bottom center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }